<template>
    <!-- <title>Generate Proposal</title> -->
    <div class="px-4 py-4">
        <div class="grid grid-cols-3 gap-2 ">
        
            <div class="col-span-1"><button class="bg-transparent hover:bg-rose-500 text-rose-700 font-semibold hover:text-white py-2 px-4 border border-rose-500 hover:border-transparent rounded" @click="sendFullProposal">Send Full Proposal</button></div>
            <div class="col-span-1"><button class="bg-transparent hover:bg-rose-500 text-rose-700 font-semibold hover:text-white py-2 px-4 border border-rose-500 hover:border-transparent rounded" @click="sendBriefProposal">Send Brief Proposal</button></div>
            <div class="col-span-1"><button class="bg-transparent hover:bg-rose-500 text-rose-700 font-semibold hover:text-white py-2 px-4 border border-rose-500 hover:border-transparent rounded" @click="sendProposalQuote">Send Proposal Quote</button></div>
          
        </div>
        <div class="py-4">
            <iframe
                :src="myIframe"
                width="100%"
                height="400"
                id="proposalFrame"
                frameborder="0" v-show="myIframe">
            </iframe>
                <div class="px-4">
                    <hr>
                </div>
                
        </div>
       
        <div class="py-4 px-8" v-if="myIframe">
            
            <form @submit="onSubmit">
                <div class="flex flex-col gap-6">
                    <div><app-label ><strong>To</strong> </app-label> <multiselect v-model="toSelected" :options="toOptions"  placeholder="Enter Receipents" :taggable="true" @tag="toOptionAdd" required></multiselect></div>
                    <div><app-label ><strong>Cc</strong> </app-label> <multiselect v-model="ccSelected" :options="ccOptions" :multiple="true" :taggable="true" @tag="addTag" placeholder="Enter Receipents" required></multiselect></div>
                    <div> <app-label ><strong>Subject</strong> </app-label><app-input v-model:value="emailSubject" placeholder="Enter Subject" required></app-input></div>
                    <div> <app-label ><strong>Email Body</strong> </app-label> <app-textarea v-model:value="emailBody" placeholder="Enter Email Body" paddingClass="py-4 px-4 pb-12" required></app-textarea></div>
                    <div v-show="foundError"> <div class="flex items-center text-rose-500 mt-2 mb-4 ml-2" style="white-space: pre;">{{ errorMessage }}</div></div>
                    <div> <button type="submit" class="bg-transparent hover:bg-rose-500 text-rose-700 font-semibold hover:text-white py-2 px-4 border border-rose-500 hover:border-transparent rounded float-left">Send Email</button></div>
                </div>   
            </form>
        </div>
        <div v-if="showLoadingScreen" class="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-slate-300">
            <loading paddingClass="px-3 py-1" bgColorClass="bg-gray-400">
                {{ loadingText }}
            </loading>
        </div>
        <div
            class="fixed z-10 top-0 left-0 flex items-center justify-center w-screen h-screen bg-gray-600/50 transition-all ease-in duration-75"
            :class="{'opacity-0 invisible pointer-events-none scale-75': !showPopUpModal,}"
        >
            <div class="px-10 py-5 bg-white rounded-lg ring-2 w-auto">
                <div class="flex items-center text-rose-500 mt-2 mb-4 ml-2" style="white-space: pre;">{{ message }}</div>
                <div class="flex justify-center mt-2">
                    <button
                        @click="showPopUpModal = false"
                        class="w-1/4 px-4 text-sm font-semibold text-white bg-gray-500 border-2 border-green-500 shadow leading-6 rounded-md transition ease-in-out duration-150"
                    >
                        Ok
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from "@/components/Loading";
import {generateReqProposal , sendEmailToClient  } from "@/services/ShortlistedSpeakerService";
import AppTextarea from "@/components/AppTextarea";
import AppInput from "@/components/AppInput";
import AppLabel from "@/components/AppLabel";
import Multiselect from 'vue-multiselect';
import { isArray } from "lodash";

 
export default {
  name: 'MyIframe',
  components: {
    Loading,
    AppTextarea,
    AppInput,
    Multiselect,
    AppLabel
  },
  data: () => ({
    myIframe: null,
    showLoadingScreen: false,
    loadingText: 'Please Wait!',
    showPopUpModal: false,
    toSelected: '',
    ccSelected: [],
    toOptions: [],
    ccOptions: [],
    message: '',
    contactEmail: '',
    contactFirstName: '',
    emailSubject: '',
    emailBody: '',
    updatedEmailBody: '',
    client_email: '',
    cc_emails: '',
    pdf_url: '',
    foundError: false,
    errorMessage : '',
    proposal_name: null,
    loginUserId: '',
    loginUserName: '',
    loginUserPhone: '',
    loginUserMobile: '',
    loggedInUserRole: '',
    dealInfo: {
        deal_id: null,
        name: null,
        client_name: null,
        contactId: null,
        saxton_or_csnz: null
    },
  }),
  head: {
    // creates a title tag in header.
    title () {
      return {
        inner: 'New Proposal'
      }
    },
    meta: [
      // creates a meta description tag in header.
      { name: 'New Proposal', content: 'New Proposal' }
    ]
  },
  async mounted() {
    await this.init()
  },
  /* global ZOHO */
  methods: {
    async init() {
        this.showLoadingScreen = true
        ZOHO.embeddedApp.on('PageLoad', async (data) => {
    
            await ZOHO.CRM.API.getRecord({
                Entity: data.Entity,
                RecordID: data.EntityId,
            }).then((response) => {
                let data = response.data[0];
                this.updatedDealFields(data);
                if (this.dealInfo.client_name === undefined)
                {
                    this.showPopUpNotification('Contact Not Assigned');
                    return false;
                }else {
                    this.getClientEmail(this.dealInfo.contactId);
                }
                this.showLoadingScreen = false;
            })

            const user_res =  await ZOHO.CRM.CONFIG.getCurrentUser();
            if (user_res)
            {
                const currentUserDetails = user_res.users[0];
                
                this.loginUserId = currentUserDetails.id;
                this.loginUserName = currentUserDetails.full_name;
                const getUserDetails = await ZOHO.CRM.API.getUser({ID:currentUserDetails.id});
                if (getUserDetails.users)
                {
                    const userDetails = getUserDetails.users[0];

                    console.log(userDetails);
                    let userEmail = userDetails.email;
                    this.loginUserMobile = userDetails.mobile;
                    this.loginUserPhone = userDetails.phone;
                    this.loggedInUserRole = userDetails.role.name;
                }
                
            }     
        })
        ZOHO.embeddedApp.init()
        
    },
    sendFullProposal(){   
        this.myIframe = null;
        this.showLoadingScreen = true;
        this.proposal_name = 'sendProposal';
        this.emailSubject = this.dealInfo.name;
        let arg = {"opportunity_id": this.dealInfo.deal_id, "proposal_name": this.proposal_name}
        this.generateProposal(arg);    
    },
    sendBriefProposal(){
       
        this.myIframe = null;
        this.showLoadingScreen = true;
        this.proposal_name = 'sendBriefProposal';
        this.emailSubject = this.dealInfo.name;
        let arg = {"opportunity_id": this.dealInfo.deal_id, "proposal_name": this.proposal_name}
        this.generateProposal(arg);    
        
    },
    sendProposalQuote(){
        this.myIframe = null;
        this.showLoadingScreen = true;
        this.proposal_name = 'sendProposalQuote';
        this.emailSubject = this.dealInfo.name;
        let arg = {"opportunity_id": this.dealInfo.deal_id, "proposal_name": this.proposal_name}
        this.generateProposal(arg);   
    },
    async getClientEmail(contactId)
    {
       const contactRes =  await ZOHO.CRM.API.getRecord({
                Entity: 'Contacts',
                RecordID: contactId});
        if (contactRes.data)
        {
            let data = contactRes.data[0];
            this.contactEmail = data.Email; 
            this.contactFirstName = data.First_Name;
        }
    },
    async generateProposal(arg)
    {
        const proposalResponse = await generateReqProposal(arg);
        const res = proposalResponse.data;
        if (res.status == "success")
        {  
            this.showLoadingScreen = false;
            this.defaultEmailSetup(res.url,res.pdf_url);
            this.pdf_url = res.pdf_url;
            this.myIframe = res.url;
            this.changeSrc(this.myIframe);  
        } else 
        {
            this.showLoadingScreen = false;
            this.showPopUpNotification(res.message);
        }
    },
    showPopUpNotification(msg){
        this.message = msg;
        this.showPopUpModal = true;
    },
    updatedDealFields(data)
    {
        this.dealInfo.deal_id           = data.id;
        this.dealInfo.name              = data.Deal_Name;
        this.dealInfo.saxton_or_csnz    = data.Saxton_or_CSNZ;
        this.dealInfo.client_name       = data.Contact_Name?.name;
        this.dealInfo.contactId         = data.Contact_Name?.id;
    },
    defaultEmailSetup(public_url,pdf_url)
    {
        if (this.contactEmail)
        {
            this.toOptions = [];
            this.toSelected = [];
            this.toOptions.push(this.contactEmail);
            this.toSelected.push(this.contactEmail);
        }
        this.emailBody = this.generateEmailBody(public_url,pdf_url,this.contactFirstName,this.loginUserName);
    },
    changeSrc(fullPath)
    {
        top.document.getElementById('proposalFrame').setAttribute("src",fullPath);
    },
    toOptionAdd (newTag) {
       
        this.toOptions.push(newTag)
        this.toSelected = newTag;
    }, 
    addTag (newTag) {
       
        this.ccOptions.push(newTag)
        this.ccSelected.push(newTag)
    }, 
    async onSubmit(event) {
        event.preventDefault();
        if (this.toSelected == null)
        {
            this.foundError = true;
            this.errorMessage = 'No recepient is selected';
        }
        else if (this.emailSubject == '')
        {
            this.foundError = true;
            this.errorMessage = 'Email subject is empty.';
        } else if (this.emailBody == '')
        {
            this.foundError = true;
            this.errorMessage = 'Email Body is empty.'; 
        } else {
            
            if (isArray(this.toSelected))
            {
                this.client_email = this.toSelected[0];
            } else {
                this.client_email = this.toSelected;
            }
            
            this.cc_emails = this.ccSelected;
           
            this.showLoadingScreen = true;
            this.loadingText = 'Sending...';
            this.updatedEmailBody = this.emailBody.replaceAll('\n', '<br>');
            this.updatedEmailBody = this.updatedEmailBody.replaceAll(this.pdf_url, '<a href="'+this.pdf_url+'">Download PDF here</a>');
            const email_param =  {
                "email_subject": this.emailSubject,
                "public_url": this.myIframe,
                "client_email": this.client_email,
                "cc_emails": this.cc_emails,
                "email_body": this.updatedEmailBody,
                "dealId": this.dealInfo.deal_id, 
                "proposal_name": this.emailSubject,
                "loginUserId": this.loginUserId,
            };
            const proposalResponse = await sendEmailToClient(email_param);
            const res = proposalResponse.data;
            if (res.status == "success")
            { 
                this.showLoadingScreen = false;
                this.showPopUpNotification('Email has been sent successfully!');
            } else{
                this.showLoadingScreen = false;
                this.showPopUpNotification(res.message);
            }
        }
       
    }
    ,generateEmailBody(url,pdf_url,client_name,user_name)
    {
        let phoneText , mobileText,ConsultantsInfo;
        let loggedInUserRole = this.loggedInUserRole;
        loggedInUserRole = loggedInUserRole.replace(/New Zealand|Australian|- New Zealand|- Australia/gi,"").trim();
        if (this.dealInfo.saxton_or_csnz == 'CSNZ')
        {
            ConsultantsInfo = 'CSNZ Speakers Bureau';
        } else {
            ConsultantsInfo = 'Saxton Speakers Bureau';
        }
        
        if(this.loginUserPhone)
        {
            phoneText = 'Tel: '+this.loginUserPhone;

        }else{
            phoneText = '';
        }

        if(this.loginUserMobile)
        {
            mobileText = 'Mob: '+this.loginUserMobile;
            mobileText = (phoneText !='') ? ' / '+mobileText : mobileText;
        } else {
            mobileText = '';
        }
        let emailBody = 'Hi '+client_name+',\n\nThanks for your enquiry about your upcoming event; I would be delighted to assist you.  \n\nI’ve put together a selection of suggested talent as per your brief via our online proposal link here: \n'+url+' \n\nIf you would prefer to download the proposal as a PDF, click on this link:\n'+pdf_url+'\n\nIf you would like me to check the availability of any of the proposed talent for a selected date, please let me know.\n\nPlease don\'t hesitate to contact me if you require any further information or would like more ideas to discuss.\n\nI look forward to hearing from you.\n\nKind regards,\n\n'+user_name+'\n'+loggedInUserRole+'\n'+ConsultantsInfo+'\n'+phoneText+mobileText;
        return emailBody;
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>